'use client';

import { StepsFlowEnum } from '@/config/steps.config';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';

const WidgetServiceStepNotFound = () => {
  const t = useTranslations('Widget.pages.steps.services.notFound');
  const searchParams = useSearchParams();

  const isFromStoreLocator = useMemo(() => {
    return (
      searchParams?.get('mode') === StepsFlowEnum.STORE_LOCATOR &&
      searchParams?.get('storeId')
    );
  }, [searchParams]);

  useEffect(() => {
    if (isFromStoreLocator) {
      console.warn('Store ID is not matching with an existing shop.');
    }
  }, [isFromStoreLocator]);

  return (
    <main className='flex h-full flex-col items-center justify-center p-4'>
      <h1 className='text-center vp-title-s mb-2'>{t('title')}</h1>
      {isFromStoreLocator ? (
        <h2 className='text-center vp-body-m'>
          {t('descriptionFromStoreLocator')}
        </h2>
      ) : (
        <h2 className='text-center vp-body-m'>{t('description')}</h2>
      )}
    </main>
  );
};

export default WidgetServiceStepNotFound;
